import { useMutation } from 'react-query';

import {
  UpdateStripeCustomerLocationParams,
  updateStripeCustomerLocation,
} from '@utils/backend-api/stripe';

export default function useUpdateStripeCustomerLocation() {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: UpdateStripeCustomerLocationParams) => updateStripeCustomerLocation(params)
  );
  return { mutate, mutateAsync, isLoading, isError };
}
